<template>
    <CardPage :section="19" :page="2" :nextDisabled="nextDisabled" ref="cardPage">
        <v-window v-model="profileIndex" :touchless="true" :reverse="reverse" v-if="!allProfilesSwiped || dialog">
            <v-window-item v-for="(key, index) in profilesOrder" :key="index">
                <v-container fluid pa-0>
                    <v-layout row wrap align-center>
                        <v-flex xs12>
                            <ResponsiveImage flex="xs12" :src="profiles[key].image" :min-height="200" :alt="profiles[key].imageText"></ResponsiveImage>
                            <div><span class="font-weight-bold">Screenname:</span> {{ profiles[key].screenname }}</div>
                            <div><span class="font-weight-bold">Stats:</span> {{ profiles[key].stats }}</div>
                            <div><span class="font-weight-bold">Relationship status:</span> {{ profiles[key].status }}</div>
                            <div><span class="font-weight-bold">Looking for:</span> {{ profiles[key].looking }}</div>
                            <p class="mt-3">{{ profiles[key].blurb }}</p>
                            <div class="text-xs-left font-italic grey--text"><v-icon small>arrow_back</v-icon> Swipe LEFT to pass</div>
                            <div class="text-xs-right font-italic grey--text">Swipe RIGHT to accept and CHAT NOW <v-icon small>arrow_forward</v-icon></div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-window-item>
        </v-window>
        <div v-else>
            <p class="text-xs-center">You've viewed all of the profiles!</p>
        </div>
        <v-dialog v-model="dialog" persistent v-if="currentSwipe">
            <v-card class="client-dialog">
                <v-card-text>{{ profiles[profileIndex + 1][currentSwipe] }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn round outline color="primary" @click="dismiss">Ok</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </CardPage>
</template>

<script>
import Hammer from 'hammerjs';
import { get } from 'vuex-pathify';

export default {
    data() {
        return {
            dialog: false,
            currentSwipe: null,
            profileIndex: 0,
            reverse: false
        };
    },
    computed: {
        profiles: get('section19/profiles'),
        profilesOrder: get('section19/profilesOrder'),
        allProfilesSwiped: get('section19/allProfilesSwiped')
    },
    mounted() {
        this.hammer = new Hammer(this.$el);
        this.hammer.on('swipeleft', () => {
            this.currentSwipe = 'left';
            this.$store.set(`section19/profiles@${this.profileIndex + 1}.swipe`, 'left');
            this.reverse = false;
            this.dialog = true;
        });
        this.hammer.on('swiperight', () => {
            this.currentSwipe = 'right';
            this.$store.set(`section19/profiles@${this.profileIndex + 1}.swipe`, 'right');
            this.reverse = true;
            this.dialog = true;
        });
    },
    destroyed() {
        this.hammer.destroy();
    },
    methods: {
        dismiss() {
            this.profileIndex = this.profileIndex + 1 === this.profilesOrder.length ? 0 : this.profileIndex + 1;
            this.currentSwipe = null;
            this.dialog = false;

            if (!this.nextDisabled()) {
                this.$refs.cardPage.nextClick();
            }
        },
        nextDisabled() {
            return !this.allProfilesSwiped;
        }
    }
};
</script>
